(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ra-birthday-form"] && !Shopify.designMode) return;
  try {
    (() => {
  function initBirthdayForms() {
    document.querySelectorAll('[data-ra-birthday-box]').forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = 'true';
      const form = box.querySelector('[data-ra-birthday-form]');
      if (!form) return;
      const date = form.querySelector('[data-birthday-date]');
      const tags = form.querySelector('[data-birthday-tags]');
      const button = form.querySelector('button[type="submit"]');
      const status = box.querySelector('[data-birthday-status]');
      const refresh = box.querySelector('[data-birthday-refresh]');
      const key = 'ra-birthday-pending:' + (box.dataset.customerId || 'guest');
      const today = new Date();
      date.max = today.getFullYear() + '-' + String(today.getMonth()+1).padStart(2,'0') + '-' + String(today.getDate()).padStart(2,'0');
      button.disabled = false;
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        tags.value = 'newsletter,ra-birthday-request,ra-birthday-v1:' + Date.now() + ':' + date.value;
        try { sessionStorage.setItem(key, JSON.stringify({date:date.value,at:Date.now()})); } catch {}
        button.disabled = true;
        button.textContent = box.dataset.sending;
      });
      const params = new URLSearchParams(window.location.search);
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
      const posted = form.querySelector('[data-birthday-posted]') || params.get('customer_posted') === 'true';
      if (!posted || !pending || Date.now() - pending.at > 600000 || form.querySelector('[role="alert"]')) return;
      function showStatus(message) { status.textContent = message; status.hidden = false; }
      function clearPending() { try { sessionStorage.removeItem(key); } catch {} }
      if (!box.dataset.customerId) {
        showStatus(box.dataset.received);
        form.hidden = true;
        clearPending();
        return;
      }
      if (box.dataset.savedDate === pending.date) {
        showStatus(box.dataset.updated);
        clearPending();
        return;
      }
      const editor = box.querySelector('[data-birthday-editor]');
      if (editor) editor.open = false;
      showStatus(box.dataset.pending);
      button.disabled = true;
      let attempts = 0;
      async function checkSavedDate() {
        attempts += 1;
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('customer_posted');
          url.searchParams.set('section_id', box.dataset.sectionId);
          url.searchParams.set('_birthday_check', String(Date.now()));
          const response = await fetch(url.toString(), {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) throw new Error('unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const saved = Array.from(doc.querySelectorAll('[data-ra-birthday-box]')).find((item) => item.dataset.customerId === box.dataset.customerId);
          if (saved && saved.dataset.savedDate === pending.date) {
            clearPending();
            const clean = new URL(window.location.href);
            clean.searchParams.delete('customer_posted');
            window.location.replace(clean.toString());
            return;
          }
        } catch {}
        if (attempts < 6) { window.setTimeout(checkSavedDate, 2000); return; }
        showStatus(box.dataset.pendingSlow);
        refresh.hidden = false;
        button.disabled = false;
      }
      window.setTimeout(checkSavedDate, 1200);
    });
  }
  initBirthdayForms();
  document.addEventListener('shopify:section:load', initBirthdayForms);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-collection-card-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-collection-card-video')) {
    class RaCollectionCardVideo extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.events) return;
        const template = this.querySelector('template');
        const link = this.closest('a');
        const card = this.closest('.m-product-card');
        if (!template || !link || !card || !('IntersectionObserver' in window)) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'ra-collection-video-toggle';
        this.retryCount = 0;
        this.button.hidden = true;
        link.insertAdjacentElement('afterend', this.button);
        this.button.addEventListener('click', () => {
          this.userPaused = Boolean(this.video && !this.video.paused && !this.needsGesture && !this.failed);
          if (!this.userPaused) {
            this.manualPlay = true;
            this.needsGesture = false;
            this.retryCount = 0;
            if (this.failed) {
              this.failed = false;
              this.playAttempt = null;
              this.video?.load();
            }
          }
          this.syncPlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('pageshow', () => this.syncPlayback(), options);
        this.reducedMotion.addEventListener('change', () => {
          this.manualPlay = false;
          this.syncPlayback();
        }, options);
        const selectVariant = (event) => {
          if (!event.target.closest('pcard-swatch, .m-product-option--node__label, .m-product-option--dropdown-select')) return;
          this.variantSelected = true;
          this.syncPlayback();
          this.removeAttribute('data-ready');
          this.button.hidden = true;
        };
        card.addEventListener('click', selectVariant, options);
        card.addEventListener('change', selectVariant, options);
        this.observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
            this.syncPlayback();
          }
        }, { threshold: [0, 0.25] });
        this.observer.observe(link);
        this.updateButton();
      }

      canPlay() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.variantSelected && (!this.reducedMotion.matches || this.manualPlay) && !this.failed && !this.needsGesture;
      }

      syncPlayback() {
        if (!this.canPlay()) {
          clearTimeout(this.recoveryTimer);
          this.video?.pause();
          if (this.reducedMotion.matches && !this.manualPlay) {
            this.removeAttribute('data-ready');
          }
          this.updateButton();
          return;
        }
        if (!this.video) {
          this.append(this.querySelector('template').content.cloneNode(true));
          this.video = this.querySelector('video');
          if (!this.video) return;
          const options = { signal: this.events.signal };
          this.video.muted = true;
          this.video.defaultMuted = true;
          this.video.playsInline = true;
          this.video.addEventListener('playing', () => {
            if (!this.canPlay()) { this.video.pause(); return; }
            clearTimeout(this.recoveryTimer);
            this.setAttribute('data-ready', '');
            this.updateButton();
          }, options);
          this.video.addEventListener('pause', () => this.updateButton(), options);
          this.video.addEventListener('waiting', () => this.scheduleRecovery(), options);
          this.video.addEventListener('stalled', () => this.scheduleRecovery(), options);
          this.video.addEventListener('error', () => {
            this.failed = true;
            this.removeAttribute('data-ready');
            this.updateButton();
          }, options);
        }
        this.updateButton();
        if (this.playAttempt || !this.video.paused) return;
        const attempt = {};
        this.playAttempt = attempt;
        this.scheduleRecovery();
        Promise.resolve(this.video.play()).catch((error) => {
          if (this.playAttempt !== attempt || !this.isConnected) return;
          if (error.name === 'AbortError') {
            if (this.canPlay()) this.scheduleRecovery();
            return;
          }
          clearTimeout(this.recoveryTimer);
          this.needsGesture = true;
          this.updateButton();
        }).finally(() => {
          if (this.playAttempt === attempt) this.playAttempt = null;
        });
      }

      scheduleRecovery() {
        clearTimeout(this.recoveryTimer);
        if (!this.canPlay() || !this.video) return;
        const time = this.video.currentTime;
        this.recoveryTimer = setTimeout(() => {
          if (!this.canPlay() || this.video.currentTime !== time) return;
          if (this.retryCount >= 1) {
            this.needsGesture = true;
            this.playAttempt = null;
            this.video.pause();
            this.updateButton();
            return;
          }
          this.retryCount += 1;
          this.playAttempt = null;
          this.video.load();
          this.syncPlayback();
        }, 8000);
      }

      updateButton() {
        if (!this.button) return;
        const playing = this.video && !this.video.paused && !this.userPaused && !this.needsGesture && !this.failed;
        this.button.hidden = Boolean(this.variantSelected || (!this.video && !this.reducedMotion.matches));
        this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
        this.button.innerHTML = !playing
          ? '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M4 2v12l10-6z"/></svg>'
          : '<svg viewBox="0 0 16 16" aria-hidden="true"><path fill="currentColor" d="M3 2h3v12H3zm7 0h3v12h-3z"/></svg>';
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        clearTimeout(this.recoveryTimer);
        this.observer?.disconnect();
        this.events?.abort();
        this.playAttempt = null;
        this.video?.pause();
        this.video?.remove();
        this.video = null;
        this.failed = false;
        this.needsGesture = false;
        this.removeAttribute('data-ready');
        this.button?.remove();
        this.events = null;
      }
    }
    customElements.define('ra-collection-card-video', RaCollectionCardVideo);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-collection-quickview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-quickview-zoom')) {
    customElements.define('ra-quickview-zoom', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this.events || !document.body.matches('.template-collection, .template-index:has(ra-shoppable-videos)')) return;
        this.gallery = this.parentElement.querySelector('media-gallery');
        this.button = this.querySelector('.ra-qv-zoom__open');
        this.dialog = this.querySelector('dialog');
        this.image = this.querySelector('.ra-qv-zoom__image');
        if (!this.gallery || !this.button || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.button.addEventListener('click', () => this.open(), options);
        this.querySelector('.ra-qv-zoom__close').addEventListener('click', () => this.close(), options);
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('close', () => {
          this.image.removeAttribute('src');
          if (this.isConnected) this.button.focus({ preventScroll: true });
        }, options);
        document.addEventListener('keydown', (event) => {
          if (!this.dialog.open) return;
          event.stopImmediatePropagation();
          if (event.key === 'Escape') {
            event.preventDefault();
            this.suppressEscape = true;
            this.close();
          }
        }, { ...options, capture: true });
        document.addEventListener('keyup', (event) => {
          if (this.dialog.open || (this.suppressEscape && event.key === 'Escape')) {
            event.stopImmediatePropagation();
            this.suppressEscape = false;
          }
        }, { ...options, capture: true });
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.gallery, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-media-src'] });
        this.update();
      }

      activeImage() {
        const slide = this.gallery.querySelector('.swiper-slide-active') || this.gallery.querySelector('.m-product-media--item');
        if (slide?.dataset.mediaType !== 'image') return null;
        return slide.querySelector('.m-product-media[data-media-src]');
      }

      update() {
        this.button.hidden = !this.activeImage();
      }

      open() {
        const media = this.activeImage();
        if (!media || this.dialog.open) return;
        this.image.alt = media.dataset.mediaAlt || media.querySelector('img')?.alt || '';
        this.image.src = media.dataset.mediaSrc;
        this.dialog.showModal();
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.close();
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-daily-sales-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-daily-sales-badge')) {
    customElements.define('ra-daily-sales-badge', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        this.expireIfNeeded = () => {
          clearTimeout(this.expiryTimer);
          const deadline = Number(this.dataset.validUntil) * 1000;
          const remaining = deadline - Date.now();
          if (!Number.isFinite(deadline) || remaining <= 0 || remaining > 86400000) {
            this.remove();
            return;
          }
          this.expiryTimer = setTimeout(this.expireIfNeeded, remaining + 20);
        };
        document.addEventListener('visibilitychange', this.expireIfNeeded, { signal: this.abortController.signal });
        window.addEventListener('pageshow', this.expireIfNeeded, { signal: this.abortController.signal });
        this.expireIfNeeded();
      }
      disconnectedCallback() {
        clearTimeout(this.expiryTimer);
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-look-outfit-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-look-outfit')) {
    customElements.define('ra-look-outfit', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
        } else {
          this.initialize();
        }
      }

      initialize() {
        this.dialog = this.querySelector('.ra-outfit-dialog');
        this.trigger = this.querySelector('[data-outfit-open]');
        if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
        const signal = this.controller.signal;
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => {
          if (!this.dialog.open) this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
        }, { signal });
        this.querySelector('[data-outfit-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => {
          this.trigger.setAttribute('aria-expanded', 'false');
        }, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('.ra-outfit-card')) {
            this.dialog.close();
            this.trigger.focus({ preventScroll: true });
            return;
          }
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            this.dialog.close();
          }
        }, { signal });
      }

      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-product-title-wishlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ra-product-title-wishlist')) {
    customElements.define('ra-product-title-wishlist', class extends HTMLElement {
      connectedCallback() {
        this.syncLabel = () => {
          const button = this.querySelector('.wishlist-plp-btn-wrap');
          if (!button) return;
          const active = button.classList.contains('active');
          const label = active ? this.dataset.removeLabel : this.dataset.addLabel;
          button.setAttribute('aria-label', label);
          button.setAttribute('aria-pressed', String(active));
          button.setAttribute('title', label);
          button.querySelectorAll('svg').forEach((icon) => icon.setAttribute('aria-hidden', 'true'));
        };
        this.observer = new MutationObserver(this.syncLabel);
        this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        this.syncLabel();
        if (!this.querySelector('.wishlist-plp-btn-wrap') && typeof window.wishlistButtonsInit === 'function') {
          window.wishlistButtonsInit();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-recommended-looks-link"] && !Shopify.designMode) return;
  try {
    let recommendedHeaderObserver;
  function observeRecommendedHeader() {
    if (recommendedHeaderObserver) recommendedHeaderObserver.disconnect();
    const header = document.querySelector('m-header .m-header__wrapper');
    if (!header) return;
    const updateHeight = () => {
      document.documentElement.style.setProperty('--ra-recommended-header-height', header.getBoundingClientRect().height + 'px');
    };
    recommendedHeaderObserver = new ResizeObserver(updateHeight);
    recommendedHeaderObserver.observe(header);
    updateHeight();
  }
  observeRecommendedHeader();
  document.addEventListener('shopify:section:load', observeRecommendedHeader);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ra-search-discovery"] && !Shopify.designMode) return;
  try {
    function initRaSearchDiscovery() {
    document.querySelectorAll('.ra-search-popup').forEach((popup) => {
      if (popup.dataset.raSearchReady) return;
      popup.dataset.raSearchReady = 'true';
      const panel = popup.querySelector('[data-search-container]');
      const input = popup.querySelector('[data-search-input]');
      const discovery = popup.querySelector('[data-ra-search-discovery]');
      const close = popup.querySelector('[data-close-search]');
      const predictive = popup.querySelector('predictive-search');
      let returnFocus = null;
      let wasOpen = false;
      const syncQuery = () => {
        const hasQuery = input.value.trim().length > 0;
        popup.dataset.raQuery = String(hasQuery);
        discovery.hidden = Boolean(hasQuery && predictive);
      };
      const syncViewport = () => {
        if (window.visualViewport) popup.style.setProperty('--ra-search-viewport', `${window.visualViewport.height}px`);
      };
      input.addEventListener('input', syncQuery);
      popup.querySelector('[data-clear-search]').addEventListener('click', () => {
        input.value = '';
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          close.click();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = [...popup.querySelectorAll('a[href], button, input:not([type="hidden"]), [tabindex="0"]')].filter((el) => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last?.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, true);
      new MutationObserver(() => {
        const isOpen = panel.classList.contains('m-show-search');
        if (isOpen === wasOpen) return;
        wasOpen = isOpen;
        popup.setAttribute('aria-hidden', String(!isOpen));
        if (isOpen) {
          if (!popup.contains(document.activeElement)) returnFocus = document.activeElement;
          syncQuery();
          syncViewport();
          window.RaNewestSearch?.refreshArrivals(discovery);
        } else {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          returnFocus?.focus({ preventScroll: true });
        }
      }).observe(panel, { attributes: true, attributeFilter: ['class'] });
      window.visualViewport?.addEventListener('resize', syncViewport);
      syncViewport();
      syncQuery();
    });
  }
  initRaSearchDiscovery();
  document.addEventListener('shopify:section:load', initRaSearchDiscovery);
  } catch(e) { console.error(e); }
})();

})();
